<template>
	<transition>
		<div class="no-results">
			<SvgIcon class="no-results__icon" iconName="ico-searchbig"/>
			<span class="no-results__content">Sorry, no results have <br> been found</span>
		</div>
	</transition>
</template>

<script>
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';

export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},

	data () {
		return {
			
		};
	},
	components: {
		SvgIcon
	}
};
</script>

<style lang="scss" scoped>
.no-results {
	padding: 139px 0;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	z-index: 999;
	position: relative;

	@include mq($xl) {
		padding: 100px 0;
	}

	@include mq($lg) {
		padding: 80px 0;
	}

	@include mq($md) {
		padding: 60px 0;
	}

	@include mq($sm) {
		padding: 40px 0;
	}
}
.no-results__content {
	font-family: $font-main;
	font-weight: 500;
	font-size: 24px;
	line-height: 32px;
	display: flex;
	align-items: center;
	text-align: center;
	color: $silver-chalice;
	z-index: 1;

	@include mq($md) {
		line-height: 1.2;
		font-size: 20px;
	}
}

.no-results__icon {
	font-style: normal;
	font-weight: 300;
	font-size: 64px;
	line-height: 64px;
	display: flex;
	align-items: center;
	text-align: center;
	color: $silver-chalice;
	z-index: 1;
	margin-bottom: 22px;

	@include mq($lg) {
		font-size: 55px;
		margin-bottom: 20px;
	}

	@include mq($sm) {
		font-size: 45px;
	}
}
</style>
